module.exports = __webpack_public_path__ + "static/media/GoogleBooks.02e716cc.PNG";